import api from './api';
import { captureSession, assertCurrentSession } from '../utils/authSession';
async function post(url, body) {
  const session = captureSession();
  const response = await api.request({ method: 'post', url, data: body, sessionBinding: session });
  assertCurrentSession(session);
  return response.data?.data ?? response.data;
}
const feedbackService = {
  claim: (operationId) => post('/feedback/claim', { operationId }),
  respond: (promptId, response) => post('/feedback/respond', { promptId, response }),
  search: (body) => post('/admin/audit-logs/feedback/search', body),
};
export default feedbackService;
